import { BaseApi } from '@/main/baseApi';
import { DMS_MODULE } from '@/modules/ciselnik/dilenske/odlozenaServisniCinnost/constants';

import { API_NAME } from './constants';

export const apiProvider = new BaseApi(DMS_MODULE, API_NAME);
